type EnumValueType = string | number | null;

type EnumEntryType<T> = {
    id: EnumValueType,
    name: string
} & T & object;

type EnumType<Key extends string, Value> = {
    items: EnumEntryType<Value>[],
    values: Key[],
} & Record<Key, Value>;

export const makeEnum = <Value extends EnumEntryType<any>, Key extends string>(entries: Record<Key, Value>): EnumType<Key, Value> => {
    const items: EnumEntryType<Value>[] = Object.values(entries);
    const result: Record<string, any> = {
        items: items,
        values: items.map(item => item.id),
    };
    for (const key in entries) {
        result[key as string] = entries[key];
    }
    return result as EnumType<Key, Value>;
}
